// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"2cf076db","176":"468a67ca","213":"e41d6ce3","323":"b9c46e6f","444":"a9a7fd1f","475":"1a0b77bb","825":"6b3b017e"}[chunkId] + ".chunk.js";
};